import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

import { AuthenticationService } from './core/services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLogin: boolean;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.isLogin = false;
  }

  ngOnInit(): void {
    this.authenticationService.user$.pipe(take(1)).subscribe((user) => {
      if (user == null) {
        const currentUrl = this.router.url.toString();
        // Chỉ chuyển về trang đăng nhập khi đang ở vùng quản lý /fox-admin.
        // Trang public (/, /san-pham, /bang-xep-hang...) KHÔNG cần đăng nhập.
        const isAdminArea = currentUrl.startsWith('/fox-admin');
        const isLoginPage = currentUrl.startsWith('/fox-admin/login');
        if (isAdminArea && !isLoginPage) {
          this.router.navigate(['/fox-admin/login']);
        }
      } else {
        this.isLogin = true;
      }
    });

    window.onkeypress = (event: any) => {      
      let isTextarea = event.target.localName=== 'textarea' || event.path?.[0]?.localName === 'textarea';

      if (event.which === 13 && !isTextarea) {
        event.preventDefault();
      }
    };  
  }
}
